import { render, staticRenderFns } from "./ImgFallback2.vue?vue&type=template&id=ce7d1096&"
import script from "./ImgFallback2.vue?vue&type=script&lang=js&"
export * from "./ImgFallback2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ce7d1096')) {
      api.createRecord('ce7d1096', component.options)
    } else {
      api.reload('ce7d1096', component.options)
    }
    module.hot.accept("./ImgFallback2.vue?vue&type=template&id=ce7d1096&", function () {
      api.rerender('ce7d1096', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2P6LHsqC8cy9Y/JS/comp/ImgFallback2.vue"
export default component.exports